// Generated on 2026-07-14T20:30:30.974Z
// This file contains preloaded categorias destacadas data from the API
// Do not edit manually - use 'npm run generate:categorias-destacadas-data' to regenerate

export const preloadedCategoriasDestacadas: any = [
  {
    "id": 133,
    "name": "Amortiguadores, Soporte de Amortiguador, Amortiguador con Espiral, Bolsa de Aire de Suspension y Repuestos para Amortiguadores",
    "slug": "amortiguadores-soporte-de-amortiguador-amortiguador-con-espiral-bolsa-de-aire-de-suspension-y-repuestos-para-amortiguadores",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/a435fa07-066a-4379-a532-4de10586a70e.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 43,
    "name": "Fricciones, Tambores y Discos de Frenos",
    "slug": "fricciones-tambores-y-discos-de-frenos",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/5e7eb696-d4ac-408e-8fa8-c9d9feb0be5d.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 128,
    "name": "Esfericas y Tijeras",
    "slug": "esfericas-y-tijeras",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/0b1feafc-5611-4f7f-a558-3438b7fba88a.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 121,
    "name": "Filtros y Pcv",
    "slug": "filtros-y-pcv",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/9796f014-63e0-4f73-aef0-5d243880fad1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 64,
    "name": "Flechas Completas, Cruces de Cardan y Puntas de Flechas",
    "slug": "flechas-completas-cruces-de-cardan-y-puntas-de-flechas",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/4155b2e3-34eb-431a-8754-9d23c5cc98b2.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 16,
    "name": "Bandas, Tensores y Poleas",
    "slug": "bandas-tensores-y-poleas",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/5e8168b7-fd89-421d-a631-a6b76bcd43d0.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 23,
    "name": "Bomba de Agua, Aspa y Fan Clutch",
    "slug": "bomba-de-agua-aspa-y-fan-clutch",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/de10c30d-2c84-4b82-bcf8-c3bdb2788621.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 19,
    "name": "Radiador, Ventiladora y Motor de Ventiladora Electrica",
    "slug": "radiador-ventiladora-y-motor-de-ventiladora-electrica",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/4a4499f3-9243-4938-9b2f-95851c24d136.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 74,
    "name": "Baterias",
    "slug": "baterias",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/ca7f59fa-d124-4db9-be5a-e6a7818b85cd.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 72,
    "name": "Alternador y Regulador de Voltaje",
    "slug": "alternador-y-regulador-de-voltaje",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos-subcategorias/9077558c-0a59-4172-8792-2df248647d66.webp",
    "mostrar_como_categoria_principal": false
  }
];

export default preloadedCategoriasDestacadas;
